module.exports = __webpack_public_path__ + "media/images/icons/v2/gift-01-c771b7a74673742676d2c0b3c6d02853.svg";